import heroBg from '../../images/Bridges_login_bg.jpg';
import { LandingHeroContainer } from './styles';

const backgroundStyle = {
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundImage: `url(${heroBg})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
};

function LandingHero({ children }) {
  return (
    <div style={backgroundStyle}>
      <LandingHeroContainer>
        {children}
      </LandingHeroContainer>
    </div>
  );
}

export default LandingHero;
